import { useState, useEffect } from 'react';
import { PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import useConfig from './use-config';

export const useMsalInstance = () => {
	const { authClientId, authTenantId } = useConfig();
	const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

	useEffect(() => {
		if (authClientId && authTenantId) {
			const msalConfig = {
				auth: {
					clientId: authClientId,
					authority: `https://login.microsoftonline.com/${authTenantId}`,
					redirectUri: typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}` : '',
				},
				cache: {
					cacheLocation: 'sessionStorage',
					storeAuthStateInCookie: false,
				},
			};

			const instance = new PublicClientApplication(msalConfig);

			const handleRedirect = async () => {
				try {
					await instance.handleRedirectPromise();
				} catch (error) {
					console.error(error);
				}
			};

			const handleLogin = async () => {
				if (instance.getAllAccounts().length === 0) {
					const scopes = ['openid', 'profile', 'User.Read'];
					const loginRequest = {
						scopes,
					} as RedirectRequest;
					await instance.loginRedirect(loginRequest);
				}
				if (instance.getActiveAccount() === null) {
					const account = instance
						.getAllAccounts()
						.find((a) => a.tenantId === authTenantId && a.idTokenClaims?.aud === authClientId);
					if (account) {
						instance.setActiveAccount(account);
					}
				}
				setMsalInstance(instance);
			};

			instance.initialize().then(handleRedirect).then(handleLogin);
		}
	}, [authClientId, authTenantId]);

	return msalInstance;
};
